import { getFavorites, selectIsLoggedIn } from 'containers/Login/loginSlice'
import { selectBasketTenantData } from 'containers/OrderDetails/basketSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import { LOCATION_STATES } from 'utils/constants'
import { useHistory } from 'react-router-dom'
import { POST } from 'rest/request'
import * as urls from 'rest/urls'
import { loginPath } from 'utils/login'
import { useRef } from 'react'

const useBasketFinalize = (
  setLoading?: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const isLoggedIn = useReduxSelector(selectIsLoggedIn)
  const tenant = useReduxSelector(selectBasketTenantData)
  const currentData = useRef({
    tenant,
    isLoggedIn
  })

  currentData.current.tenant = tenant
  currentData.current.isLoggedIn = isLoggedIn

  const { replace } = useHistory()
  const dispatch = useReduxDispatch()
  const onBoardUser = async (userId: string, callback?: basic.BasicFunc) => {
    setLoading?.(true)
    try {
      const response = await POST(urls.onboard(userId))
      if (response.link) {
        replace('/login', LOCATION_STATES.popup({ type: 'activateAccount', props: { link: response.link } }))
      } else {
        replace(loginPath(response?.login))
      }
      callback?.()
    } catch (error) {
      callback?.()
      replace('/login')
    }
  }

  const finalizeBasket = async (callback?: basic.BasicFunc) => {
    if (currentData.current.isLoggedIn) {
      callback?.()
      dispatch(getFavorites())
      replace('/newwarehouse')

    } else if (currentData.current.tenant?.user?.id) {
      onBoardUser(currentData.current.tenant.user.id, callback)

    } else {
      callback?.()
      replace('/login')
    }
  }

  return {
    onBoardUser,
    finalizeBasket
  }
}

export default useBasketFinalize